// import dragula from 'dragula';
// import 'dragula/dist/dragula.css';
//
// import Rails from 'rails-ujs';
// import superagent from 'superagent';

import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  connect() {
    // const drake = dragula([].slice.apply(document.querySelectorAll('ul[data-target="shared--nested-tree.branch"]')));
    // drake.on('dragend', () => {
    //   let categoriesWithChangedPositions = {};
    //
    //   document.querySelectorAll('ul[data-target="shared--nested-tree.branch"] > li').forEach((element, index) => {
    //     if (parseInt(element.dataset.position) !== index + 1) {
    //       categoriesWithChangedPositions[element.dataset.id] = index + 1
    //     }
    //   });
    //
    //   superagent
    //     .patch('/office/categories/reposition')
    //     .send({ 'new_positions': categoriesWithChangedPositions })
    //     .set('X-CSRF-Token', Rails.csrfToken());
    //     // .end((err, res) => {
    //     //   debugger;
    //     // });
    // });
  }

  toggle(event) {
    const target = event.currentTarget.querySelector('i');
    const categoryId = target.closest('li').dataset.id;
    const subcategories = target.closest('li').querySelector('ul[data-target="shared--nested-tree.branch"]');

    if (subcategories) {
      subcategories.classList.toggle('is-hidden');
      target.classList.toggle('fa-plus');
      target.classList.toggle('fa-minus');
    } else {
      Rails.ajax({
        type: 'GET',
        url: `/office/categories/${categoryId}/subcategories`,
        success: (response) => {
          const template = document.createElement('template');
          template.innerHTML = response.body.innerHTML;
          const content = template.content;
          target.closest('.level').after(content);
          target.closest('li').querySelector('ul[data-target="shared--nested-tree.branch"]')
              .classList.toggle('is-hidden');
          target.classList.toggle('fa-plus');
          target.classList.toggle('fa-minus');
        },
        error: () => {
          alert('Ошибка при попытке найти подкатегории');
        },
      });
    }
  }
}
